import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {z as zod} from "zod";

export type IndiaCity = {
    id: Uuid;
    name: string;
    stateId: Uuid;
};

export const indiaCityValidator: zod.ZodType<IndiaCity> = zod.strictObject({
    id: uuidZodValidator,
    name: zod.string(),
    stateId: uuidZodValidator,
});
